// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { URL } from "../../../../config";
// import Loader from "../../../../Components/LoaderSpin/Loader";
// import "./ServitorReportIssue.css";

// const ServitorReportIssue = () => {
//   const { orderNumber } = useParams();
//   const navigate = useNavigate();
//   const [order, setOrder] = useState(null);
//   const [serviceType, setServiceType] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [issueType, setIssueType] = useState("");
//   const [subject, setSubject] = useState("");
//   const [description, setDescription] = useState("");
//   const [lostItemName, setLostItemName] = useState("");
//   const [lostItemDetails, setLostItemDetails] = useState("");
//   const [showSuccess, setShowSuccess] = useState(false);

//   const ISSUE_OPTIONS = [
//     { value: "service_quality", label: "Service quality issue" },
//     { value: "behavior", label: "Customer behavior issue" },
//     { value: "overcharge_or_payment", label: "Payment or overcharge problem" },
//     { value: "late_or_no_show", label: "Customer not present / Late" },
//     { value: "safety", label: "Safety concern" },
//     { value: "lost_item", label: "Lost item" },
//     { value: "damage", label: "Damage or property issue" },
//     { value: "other", label: "Other issue" },
//   ];

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (!token) {
//       navigate("/login");
//       return;
//     }

//     setLoading(true);
//     axios
//       .get(`${URL}/orders/byOrderNumber/${orderNumber}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((res) => {
//         setOrder(res.data);
//         setServiceType(res.data.Service?.services_name);
//       })
//       .catch((err) => console.error("Error loading order:", err))
//       .finally(() => setLoading(false));
//   }, [orderNumber, navigate]); // ✅ added navigate here

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!issueType || !description.trim()) {
//       alert("Please select an issue type and describe the issue.");
//       return;
//     }

//     try {
//       const token = localStorage.getItem("token");
//       await axios.post(
//         `${URL}/reports`,
//         {
//           orderNumber,
//           serviceType,
//           issueType,
//           subject,
//           description,
//           lostItemName,
//           lostItemDetails,
//         },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       setShowSuccess(true);
//     } catch (err) {
//       console.error("Error creating report:", err);
//       alert("Failed to submit report. Please try again.");
//     }
//   };

//   if (loading) return <Loader show={true} />;

//   return (
//     <div className="servitor-report-page">
//       <div className="servitor-report-container">
//         <h2>Help & Support</h2>
//         <p>Let us know if there was an issue with this order.</p>

//         <div className="servitor-report-order-info">
//           <p>
//             <strong>Order Number:</strong> {orderNumber}
//           </p>
//           <p>
//             <strong>Service:</strong> {serviceType || "N/A"}
//           </p>
//           <p>
//             <strong>Status:</strong> {order?.status || "N/A"}
//           </p>
//         </div>

//         <form className="servitor-report-form" onSubmit={handleSubmit}>
//           <label>Issue Type</label>
//           <select
//             value={issueType}
//             onChange={(e) => setIssueType(e.target.value)}
//             required
//           >
//             <option value="">Select an issue</option>
//             {ISSUE_OPTIONS.map((opt) => (
//               <option key={opt.value} value={opt.value}>
//                 {opt.label}
//               </option>
//             ))}
//           </select>

//           <label>Subject (optional)</label>
//           <input
//             type="text"
//             value={subject}
//             onChange={(e) => setSubject(e.target.value)}
//             placeholder="Short title (optional)"
//           />

//           {issueType === "lost_item" && (
//             <>
//               <label>Lost Item Name</label>
//               <input
//                 type="text"
//                 value={lostItemName}
//                 onChange={(e) => setLostItemName(e.target.value)}
//                 placeholder="Item name"
//               />
//               <label>Lost Item Details</label>
//               <textarea
//                 rows="3"
//                 value={lostItemDetails}
//                 onChange={(e) => setLostItemDetails(e.target.value)}
//                 placeholder="Describe the lost item..."
//               />
//             </>
//           )}

//           <label>Description</label>
//           <textarea
//             rows="4"
//             value={description}
//             onChange={(e) => setDescription(e.target.value)}
//             placeholder="Describe what happened..."
//             required
//           />

//           <div className="report-actions">
//             <button
//               type="button"
//               onClick={() => navigate(-1)}
//               className="cancel-btn"
//             >
//               Cancel
//             </button>
//             <button type="submit" className="submit-btn">
//               Submit Report
//             </button>
//           </div>
//         </form>
//       </div>

//       {showSuccess && (
//         <div className="servitor-report-success-overlay">
//           <div className="servitor-report-success-box">
//             <h3>Report Submitted</h3>
//             <p>
//               Thank you for letting us know. Our team will review your report and
//               reach out if necessary.
//             </p>
//             <button onClick={() => navigate("/servitor")}>OK</button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ServitorReportIssue;






// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { URL } from "../../../../config";
// import Loader from "../../../../Components/LoaderSpin/Loader";
// import "./ServitorReportIssue.css";

// const ServitorReportIssue = () => {
//   const { orderNumber } = useParams();
//   const navigate = useNavigate();
//   const [order, setOrder] = useState(null);
//   const [serviceType, setServiceType] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [issueType, setIssueType] = useState("");
//   const [subject, setSubject] = useState("");
//   const [description, setDescription] = useState("");
//   const [lostItemName, setLostItemName] = useState("");
//   const [lostItemDetails, setLostItemDetails] = useState("");
//   const [showSuccess, setShowSuccess] = useState(false);

//   const ISSUE_OPTIONS = [
//     { value: "service_quality", label: "Service quality issue" },
//     { value: "behavior", label: "Customer behavior issue" },
//     { value: "overcharge_or_payment", label: "Payment or overcharge problem" },
//     { value: "late_or_no_show", label: "Customer not present / Late" },
//     { value: "safety", label: "Safety concern" },
//     { value: "lost_item", label: "Lost item" },
//     { value: "damage", label: "Damage or property issue" },
//     { value: "other", label: "Other issue" },
//   ];

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (!token) {
//       navigate("/login");
//       return;
//     }

//     setLoading(true);
//     axios
//       .get(`${URL}/orders/byOrderNumber/${orderNumber}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((res) => {
//         setOrder(res.data);
//         setServiceType(res.data.Service?.services_name || "Unknown Service");
//       })
//       .catch((err) => console.error("Error loading order:", err))
//       .finally(() => setLoading(false));
//   }, [orderNumber, navigate]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!issueType || !description.trim()) {
//       alert("Please select an issue type and describe the issue.");
//       return;
//     }

//     try {
//       const token = localStorage.getItem("token");
//       await axios.post(
//         `${URL}/reports`,
//         {
//           orderNumber,
//           serviceType,
//           issueType,
//           subject,
//           description,
//           lostItemName,
//           lostItemDetails,
//         },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       setShowSuccess(true);
//     } catch (err) {
//       console.error("Error creating report:", err);
//       alert("Failed to submit report. Please try again.");
//     }
//   };

//   if (loading) return <Loader show={true} />;

//   return (
//     <div className="servitor-report-wrapper">
//       <div className="servitor-report-card">
//         {/* Header */}
//         <div className="servitor-report-header">
//           <h2>Help & Support</h2>
//           <p>Let us know if there was an issue with this order.</p>
//         </div>

//         {/* Order Info */}
//         <div className="servitor-report-order-box">
//           <div className="order-info-item">
//             <strong>Order Number:</strong> <span>{orderNumber}</span>
//           </div>
//           <div className="order-info-item">
//             <strong>Service:</strong> <span>{serviceType}</span>
//           </div>
//           <div className="order-info-item">
//             <strong>Status:</strong> <span>{order?.status || "N/A"}</span>
//           </div>
//         </div>

//         {/* Form */}
//         <form className="servitor-report-form" onSubmit={handleSubmit}>
//           <label>Issue Type</label>
//           <select
//             value={issueType}
//             onChange={(e) => setIssueType(e.target.value)}
//             required
//           >
//             <option value="">Select an issue</option>
//             {ISSUE_OPTIONS.map((opt) => (
//               <option key={opt.value} value={opt.value}>
//                 {opt.label}
//               </option>
//             ))}
//           </select>

//           <label>Subject (optional)</label>
//           <input
//             type="text"
//             value={subject}
//             onChange={(e) => setSubject(e.target.value)}
//             placeholder="Short title (optional)"
//           />

//           {issueType === "lost_item" && (
//             <>
//               <label>Lost Item Name</label>
//               <input
//                 type="text"
//                 value={lostItemName}
//                 onChange={(e) => setLostItemName(e.target.value)}
//                 placeholder="Item name"
//               />
//               <label>Lost Item Details</label>
//               <textarea
//                 rows="3"
//                 value={lostItemDetails}
//                 onChange={(e) => setLostItemDetails(e.target.value)}
//                 placeholder="Describe the lost item..."
//               />
//             </>
//           )}

//           <label>Description</label>
//           <textarea
//             rows="4"
//             value={description}
//             onChange={(e) => setDescription(e.target.value)}
//             placeholder="Describe what happened..."
//             required
//           />

//           <div className="report-actions">
//             <button type="submit" className="submit-btn">
//               Submit Report
//             </button>
//             <button
//               type="button"
//               onClick={() => navigate(-1)}
//               className="cancel-btn"
//             >
//               Back
//             </button>
//           </div>
//         </form>
//       </div>

//       {showSuccess && (
//         <div className="servitor-report-success-overlay">
//           <div className="servitor-report-success-box">
//             <i className="bx bx-check-circle success-icon"></i>
//             <h3>Report Submitted</h3>
//             <p>
//               Thank you for letting us know. Our team will review your report
//               and get back to you if needed.
//             </p>
//             <button onClick={() => navigate("/servitor")}>
//               Go to Dashboard
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ServitorReportIssue;









import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { URL } from "../../../../config";
import Loader from "../../../../Components/LoaderSpin/Loader";
import "./ServitorReportIssue.css";
import { useTranslation } from "react-i18next";

const ServitorReportIssue = () => {
  const { t } = useTranslation("servitor");
  const { orderNumber } = useParams();
  const navigate = useNavigate();

  const [order, setOrder] = useState(null);
  const [serviceType, setServiceType] = useState("");
  const [loading, setLoading] = useState(false);

  // form
  const [issueType, setIssueType] = useState("");
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [lostItemName, setLostItemName] = useState("");
  const [lostItemDetails, setLostItemDetails] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);

  // Options are translated via i18n
  const ISSUE_OPTIONS = [
    { value: "service_quality", label: t("servitorReport.issue_options.service_quality") },
    { value: "behavior", label: t("servitorReport.issue_options.behavior") },
    { value: "overcharge_or_payment", label: t("servitorReport.issue_options.overcharge_or_payment") },
    { value: "late_or_no_show", label: t("servitorReport.issue_options.late_or_no_show") },
    { value: "safety", label: t("servitorReport.issue_options.safety") },
    { value: "lost_item", label: t("servitorReport.issue_options.lost_item") },
    { value: "damage", label: t("servitorReport.issue_options.damage") },
    { value: "other", label: t("servitorReport.issue_options.other") },
  ];

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    setLoading(true);
    axios
      .get(`${URL}/orders/byOrderNumber/${orderNumber}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setOrder(res.data);
        setServiceType(res.data.Service?.services_name || t("servitorReport.unknown_service"));
      })
      .catch((err) => console.error("Error loading order:", err))
      .finally(() => setLoading(false));
  }, [orderNumber, navigate, t]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!issueType || !description.trim()) {
      alert(t("servitorReport.validation.issue_type_and_description_required"));
      return;
    }

    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${URL}/reports`,
        {
          orderNumber,
          serviceType,
          issueType,
          subject,
          description,
          lostItemName,
          lostItemDetails,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setShowSuccess(true);
    } catch (err) {
      console.error("Error creating report:", err);
      alert(t("servitorReport.errors.submit_failed"));
    }
  };

  if (loading) return <Loader show={true} />;

  return (
    <div className="servitor-report-wrapper">
      <div className="servitor-report-card">
        {/* Header */}
        <div className="servitor-report-header">
          <h2>{t("servitorReport.title")}</h2>
          <p>{t("servitorReport.subtitle")}</p>
        </div>

        {/* Order Info */}
        <div className="servitor-report-order-box">
          <div className="order-info-item">
            <strong>{t("servitorReport.order_number")}:</strong> <span>{orderNumber}</span>
          </div>
          <div className="order-info-item">
            <strong>{t("servitorReport.service")}:</strong> <span>{serviceType}</span>
          </div>
          <div className="order-info-item">
            <strong>{t("servitorReport.status")}:</strong>{" "}
            <span>{order?.status || t("servitorReport.not_available")}</span>
          </div>
        </div>

        {/* Form */}
        <form className="servitor-report-form" onSubmit={handleSubmit}>
          <label>{t("servitorReport.form.issue_type")}</label>
          <select
            value={issueType}
            onChange={(e) => setIssueType(e.target.value)}
            required
          >
            <option value="">{t("servitorReport.form.select_issue_placeholder")}</option>
            {ISSUE_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>

          <label>{t("servitorReport.form.subject_optional")}</label>
          <input
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            placeholder={t("servitorReport.form.subject_placeholder")}
          />

          {issueType === "lost_item" && (
            <>
              <label>{t("servitorReport.form.lost_item_name")}</label>
              <input
                type="text"
                value={lostItemName}
                onChange={(e) => setLostItemName(e.target.value)}
                placeholder={t("servitorReport.form.lost_item_name_placeholder")}
              />
              <label>{t("servitorReport.form.lost_item_details")}</label>
              <textarea
                rows="3"
                value={lostItemDetails}
                onChange={(e) => setLostItemDetails(e.target.value)}
                placeholder={t("servitorReport.form.lost_item_details_placeholder")}
              />
            </>
          )}

          <label>{t("servitorReport.form.description")}</label>
          <textarea
            rows="4"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder={t("servitorReport.form.description_placeholder")}
            required
          />

          <div className="report-actions">
            <button type="submit" className="submit-btn">
              {t("servitorReport.actions.submit")}
            </button>
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="cancel-btn"
            >
              {t("servitorReport.actions.back")}
            </button>
          </div>
        </form>
      </div>

      {showSuccess && (
        <div className="servitor-report-success-overlay">
          <div className="servitor-report-success-box">
            <i className="bx bx-check-circle success-icon"></i>
            <h3>{t("servitorReport.success.title")}</h3>
            <p>{t("servitorReport.success.body")}</p>
            <button onClick={() => navigate("/servitor")}>
              {t("servitorReport.success.go_to_dashboard")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServitorReportIssue;
